<script>
// component
import VueAMap from 'vue-amap'
import { find } from 'lodash'
import VueQrcode from '@chenfengyuan/vue-qrcode'

// api
import stubFalse from 'lodash/stubFalse'
import ProjectListSelectSingle from './ProjectListSelectSingle'
import ProjectListInput from './ProjectListInput'
import ProjectListSelectMulty from './ProjectListSelectMulty'
import ProjectList from './ProjectList'
import StageDistribution from './StageDistribution'
import Bullets from '~/components/Bullet/index.vue'
import {
  getCommunityListByCompanyId,
  searchProjectList,
  getCommunityDistributionByCompanyId,
  getShowProjectOptions
} from '~/api/community.api'
import { getDistrictCenterList } from '~/api/amap.api'
import { getStatisticsMap } from '~/api/common.api'
import { searchProjectListByCompanyId } from '~/api/project.api'

import {
  getProjectCameraList,
  getCameraToken,
  getCommunityCameraProjectList,
  getScreenList,
  verifyPassword
} from '~/api/camera.api'

const MARKER_LEVEL = {
  PROVINCE: 0,
  CITY: 1,
  DISTRICT: 2,
  COMMUNITY: 3
}
const ZOOM_LEVEL = {
  PROVINCE: 8,
  CITY: 12,
  DISTRICT: 14,
  COMMUNITY: 15
}
const ZOOM_REGION = {
  PROVINCE: 0,
  CITY: 1,
  DISTRICT: 2,
  COMMUNITY: 3
}
export default {
  head() {
    const url = process.env.ONLINE_URL + this.$route.path
    const title = `${this.company.shortName}装修工地直播`
    const desc = `${this.company.shortName}在建工地，${this.company.shortName}装修工地直播详情，施工流程、工艺水平、装修服务全面呈现，不用出门就能看到${this.company.shortName}真实装修工地，让您的装修选择更放心！`
    const location = `province=${this.companyProvince};city=${this.companyCity}`
    return {
      title,
      meta: [
        {
          name: 'keywords',
          content: `${this.company.shortName}装修工地,${this.company.shortName}装修流程`
        },
        {
          name: 'description',
          content: desc
        },
        {
          name: 'og:url',
          content: url
        },
        {
          name: 'og:title',
          content: title
        },
        {
          name: 'og:description',
          content: desc
        },
        {
          name: 'location',
          content: location
        }
      ],
      link: [
        {
          rel: 'canonical',
          href: url
        }
      ]
    }
  },
  components: {
    Bullets,
    ProjectListInput,
    ProjectList,
    ProjectListSelectSingle,
    ProjectListSelectMulty,
    StageDistribution,
    VueQrcode
  },
  data() {
    return {
      isLocked: false,
      isManualLock: false,
      plugin: [
        {
          pName: 'ToolBar',
          liteStyle: true
        }
      ],
      isShowProjectList: false,
      inputPassword: '',
      password: '',
      isShowPassword: false,
      isShowPlayer: false,
      isPlaying: false,
      isPlayerReady: false,
      selectedProjectList: [],
      selectedCamera: {},
      player: null,
      timer: null,
      projectData: {},
      selectedProject: {},
      fullscreen: false,
      isFullScreen: false,
      isShowQr: false,
      isMapReady: false,
      userAgent: false,
      screenWidth: 0,
      screenHeight: 0,
      filter: {
        id: '',
        region: '',
        style: '',
        room: '',
        sort: '1',
        showProject: 'all'
      },
      showProject: 'all',
      target: '',
      multySelectValue: [],
      // communityDetail: [],
      searchInput: [{ value: 'This is a test' }],
      markers: [],
      provinceList: [],
      cityList: [],
      districtList: [],
      communityList: [],
      selectedCommunity: {},
      zoom: ZOOM_LEVEL.CITY + 1,
      events: {
        init: (o) => {
          // setTimeout(() => {
          this.isMapReady = true
          // }, 2000)
        },
        click: () => {
          this.isShowProjectList = false
        },
        zoomchange: (e) => {
          if (this.isLocked) {
          } else {
            this.zoom = this.mapInstance.getZoom()
          }
        }
      }
    }
  },
  computed: {
    darkMode() {
      return this.$store.state.config.mapDarkmode
    },
    mapInstance() {
      return this.$refs.mapRef.$$getInstance()
    },
    zoomRegion() {
      if (this.zoom <= ZOOM_LEVEL.PROVINCE) {
        return ZOOM_REGION.PROVINCE
      } else if (
        ZOOM_LEVEL.PROVINCE < this.zoom &&
        this.zoom <= ZOOM_LEVEL.CITY
      ) {
        return ZOOM_REGION.CITY
      } else if (
        ZOOM_LEVEL.CITY < this.zoom &&
        this.zoom <= ZOOM_LEVEL.DISTRICT
      ) {
        return ZOOM_REGION.DISTRICT
      } else {
        return ZOOM_REGION.COMMUNITY
      }
    }
  },
  watch: {
    async isMapReady(newVal) {
      if (newVal) {
        const that = this
        that.screenWidth = document.body.clientWidth
        that.screenHeight = document.body.clientHeight - 60
        if (that.screenWidth < 500) {
          this.$router.push({
            path: `/company/${this.companyId}/project-list-old`,
            query: { ...this.$route.query }
          })
          return
        }
        window.onresize = () => {
          return (() => {
            window.screenWidth = document.body.clientWidth
            that.screenWidth = window.screenWidth
            that.screenHeight = document.body.clientHeight - 60
          })()
        }
        const projectData = (await getStatisticsMap(this.companyId)).data
        // 华美乐
        if (this.companyId == 12450) {
          projectData.finishProject = 50594
          projectData.totalProject = 54878
          projectData.totalCommunity = 5236
        }
        this.projectData = projectData
        // 加载各级点的数据
        await this.initMarkers(this.companyId)
        this.markers = this.districtList
        // 确定初始中心点和比例尺
        if (this.$route.query.communityId) {
          const communityId = Number(this.$route.query.communityId)
          const result = find(this.communityList, { communityId })
          if (result) {
            this.selectedCommunity = result
            this.mapInstance.setZoom(ZOOM_LEVEL.COMMUNITY)
            this.mapInstance.setCenter(result.position)
            const res = []
            this.searchInput.map((item) => {
              if (String(item.value) === String(communityId)) {
                item.district = item.district ? item.district : '其它地区'
                res.push(item.district)
                res.push(item.name)
              }
            })
            this.multySelectValue = res
          }
        } else {
          // 确定初始比例尺,多个省则显示全国，单个省则显示省内
          const res = (
            await getCommunityDistributionByCompanyId(
              this.companyId,
              this.showProject
            )
          ).data

          if (res.provinceList && res.provinceList.length > 1) {
            this.mapInstance.setZoom(ZOOM_LEVEL.PROVINCE)
          } else {
            this.mapInstance.setZoom(ZOOM_LEVEL.CITY)
          }
          // setcenter by company position
          const res2 = await this.getNearestProject(
            this.companyLocation.longitude,
            this.companyLocation.latitude
          )
          if (res.provinceList.length > 1) {
            const target = this.provinceList.find((province) => {
              return province.name === res2.province
            })
            if (target) {
              this.mapInstance.setCenter(target.position)
            }
          } else {
            const target = this.cityList.find((city) => {
              return city.name === res2.city
            })
            if (target) {
              this.mapInstance.setCenter(target.position)
            }
          }
          // this.mapInstance.setCenter(res)
        }

        this.adjustZoomStyle({
          left: '390px'
        })
        this.$refs.listInputRef.setCurrentLocation(this.companyLocation)
      }
    },
    fullscreen() {
      this.adjustZoomStyle({
        left: this.fullscreen && !this.isShowProjectList ? '5px' : '390px'
      })
    },
    isShowProjectList() {
      this.adjustZoomStyle({
        left: this.fullscreen && !this.isShowProjectList ? '5px' : '390px'
      })
    },
    zoomRegion(newVal) {
      if (newVal === ZOOM_REGION.PROVINCE) {
        this.markers = this.provinceList
      } else if (newVal === ZOOM_REGION.CITY) {
        this.markers = this.cityList
      } else if (newVal === ZOOM_REGION.DISTRICT) {
        this.markers = this.districtList
      } else {
        this.markers = this.communityList
      }
    },
    async selectedCommunity(newVal) {
      if (newVal.onlineFlag === 'Y') {
        const res = await getCommunityCameraProjectList(
          this.companyId,
          newVal.communityId
        )
        this.selectedProjectList = res.data.projectList
      } else {
        this.selectedProjectList = []
      }
    },
    selectedCamera(newVal) {
      if (!newVal.deviceSerial) {
      } else if (!this.player) {
        this.initPlayer(newVal.deviceSerial)
      } else {
        this.player.stop().then(async () => {
          const accessToken = (await getCameraToken(newVal.deviceSerial)).token
          this.player.play({
            url: `ezopen://open.ys7.com/${newVal.deviceSerial}/1.hd.live`,
            accessToken
          })
          this.isPlaying = true
        })
      }
    },
    isShowPlayer(newVal) {
      if (!newVal && this.player) {
        this.player.stop()
        this.isPlaying = false
      }
    },
    isPlaying(newVal) {
      if (newVal) {
        if (this.timer) {
          clearTimeout(this.timer)
        }
        this.timer = setTimeout(() => {
          this.player.stop()
          this.isPlaying = false
        }, 120000)
      } else if (this.timer) {
        clearTimeout(this.timer)
      }
    }
  },
  async asyncData(context) {
    const {
      company,
      province: companyProvince,
      city: companyCity
    } = context.store.state.company
    const companyLocation = {
      latitude: company.latitude,
      longitude: company.longitude
    }
    const list = (await getDistrictCenterList()).data
    const city = [
      '北京',
      '天津',
      '上海',
      '重庆',
      '北京市',
      '天津市',
      '上海市',
      '重庆市'
    ].includes(company.provice)
      ? company.provice
      : company.city
    let target
    list.cityList.some((item) => {
      if (item.name.includes(city)) {
        target = item
        return true
      } else {
        return false
      }
    })
    const companyId = company.companyId
    let showProjectOptions = []
    const res = await getShowProjectOptions(companyId)
    if (res.code === 200) {
      showProjectOptions = res.data
    }
    return {
      company,
      companyId,
      companyCity,
      companyProvince,
      companyLocation,
      center: target ? target.center.split(',') : [108.55, 34.32],
      qrUrl: `${process.env.H5_OWNER_URL}project-list?companyId=${companyId}&targetCompanyId=${companyId}`,
      amapKey: process.env.AMAP_KEY,
      pcWorkerUrl: process.env.PC_WORKER_URL,
      showProjectOptions
    }
  },
  mounted() {
    const darkMode = localStorage.getItem('darkMode')

    if (darkMode === 'false' || darkMode === false) {
      this.$store.commit('config/setDarkmode', false)
    }
    window._AMapSecurityConfig = {
      securityJsCode: 'a592560d2111eda1de10c0e8f5cbc6a6'
    }
    // 初始化vue-amap
    VueAMap.initAMapApiLoader({
      // 高德的key
      key: this.amapKey,
      // 插件集合
      plugin: ['AMap.ToolBar', 'AMap.Geolocation'],
      // 高德 sdk 版本，默认为 1.4.4
      v: '1.4.15'
    })
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
    }
  },
  methods: {
    moveTarget,
    clearTarget,
    onFilterChange,
    initMarkers,
    moveToCommunity,
    onClickMarker,
    onClickPlayer,
    onClickCamera,
    initPlayer,
    onClickLiveProject,
    onSubmitPassword,
    onClickMakeFullScreen() {
      this.isFullScreen = !this.isFullScreen
      if (this.isFullScreen) {
        this.launchFullscreen(this.$refs.pageEl)
      } else {
        this.exitFullscreen()
      }
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen()
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen()
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen()
      }
    },
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen()
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen()
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen()
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen()
      }
    },
    findMarkerByLevel(level, name) {
      const target = this[`${level}List`].find((item) => {
        return item.name === name
      })
      return target
    },
    adjustZoomStyle({ left }) {
      // eslint-disable-next-line camelcase
      const zoom_controller_arr = document.getElementsByClassName(
        'amap-toolbar'
      )
      // eslint-disable-next-line camelcase
      const zoom_controller = zoom_controller_arr[0]
      // eslint-disable-next-line camelcase
      if (zoom_controller) {
        zoom_controller.style.left = left
        zoom_controller.style.bottom = '100px'
        zoom_controller.style.height = '390px'
      }
    },
    onClickFullScreen() {
      this.fullscreen = !this.fullscreen
    },
    onClickSelectBlur() {
      this.$refs.s_1.clear()
      this.$refs.s_2.clear()
      this.$refs.s_3.clear()
      this.$refs.s_m_1.clear()
    },
    async getNearestProject(longitude, latitude) {
      // console.log('nearest', latitude, longitude)
      const res = await searchProjectListByCompanyId({
        sort: 2,
        pageNo: 1,
        pageSize: 1,
        companyId: this.companyId,
        latitude,
        longitude,
        showProject: this.showProject
      })
      if (res.projectList && res.projectList.length) {
        return res.projectList[0]
      } else {
        return {}
      }
    },
    async getNearestProjectPoint(longitude, latitude) {
      // console.log('nearest', latitude, longitude)
      const res = await searchProjectListByCompanyId({
        sort: 2,
        pageNo: 1,
        pageSize: 1,
        companyId: this.companyId,
        latitude,
        longitude,
        showProject: this.showProject
      })
      if (res.projectList && res.projectList.length) {
        return [
          res.projectList[0].longitude || '121.32929',
          res.projectList[0].latitude || '31.303735'
        ]
      } else {
        return []
      }
    },
    onClickLock() {
      this.isLocked = !this.isLocked
      this.isManualLock = this.isLocked
    },
    async onChangeShowProject(value) {
      this.showProject = value
      await this.initMarkers(this.companyId)
      this.filter.showProject = value
      if (this.zoomRegion === ZOOM_REGION.PROVINCE) {
        this.markers = this.provinceList
      } else if (this.zoomRegion === ZOOM_REGION.CITY) {
        this.markers = this.cityList
      } else if (this.zoomRegion === ZOOM_REGION.DISTRICT) {
        this.markers = this.districtList
      } else {
        this.markers = this.communityList
      }
    }
  }
}
async function onSubmitPassword() {
  const res = await verifyPassword(this.companyId, this.inputPassword)

  const isValid = res && res.data

  if (isValid) {
    localStorage.setItem('bigscreenPassword', this.inputPassword)
    this.isShowPassword = false
    this.isShowPlayer = true
  } else {
    this.$notify.error({
      message: '密码错误！',
      duration: 2000
    })
  }
}
async function onClickLiveProject(project) {
  const res = await getProjectCameraList(this.companyId, project.projectId, 'Y')
  this.selectedProject = res.data
  const res2 = await getScreenList(this.companyId, 'live')
  const password = res2.data.password
  this.password = password
  const localPassword = localStorage.getItem('bigscreenPassword')
  const resPwd = await verifyPassword(this.companyId, localPassword)
  const isValid = resPwd && resPwd.data
  if (isValid) {
    this.isShowPlayer = true
    this.selectedCamera = this.selectedProject.deviceList[0]
  } else {
    this.isShowPassword = true
  }
}
function moveToCommunity(communityId) {
  const result = find(this.communityList, { communityId })
  if (result) {
    this.selectedCommunity = result
    this.mapInstance.setZoom(ZOOM_LEVEL.COMMUNITY)
    this.mapInstance.setCenter(result.position)
  }
}
async function initMarkers(companyId) {
  const res = (
    await getCommunityDistributionByCompanyId(companyId, this.showProject)
  ).data
  const list = (await getDistrictCenterList()).data
  const provinceList = []
  const cityList = []
  const districtList = []
  for (const province of res.provinceList) {
    if (!province.name) {
      continue
    }
    let target = {}
    list.provinceList.some((item) => {
      if (item.name.includes(province.name)) {
        target = item
        return true
      } else {
        return false
      }
    })
    if (target.name) {
      provinceList.push({
        position: target.center.split(','),
        level: MARKER_LEVEL.PROVINCE,
        name: target.name,
        count: province.count,
        onlineFlag: province.onlineFlag
      })
    }
  }
  for (const city of res.cityList) {
    if (!city.name) {
      continue
    }
    let target = {}
    list.cityList.some((item) => {
      if (item.name.includes(city.name)) {
        target = item
        return true
      } else {
        return false
      }
    })
    if (target.name) {
      cityList.push({
        position: target.center.split(','),
        level: MARKER_LEVEL.CITY,
        name: target.name,
        count: city.count,
        onlineFlag: city.onlineFlag
      })
    }
  }
  for (const district of res.districtList) {
    if (!district.name) {
      continue
    }
    let target = {}
    list.districtList.some((item) => {
      // 全国有两个城中区，特殊处理
      if (companyId === 39622 && district.name === '城中区') {
        target = {
          name: '城中区',
          center: '109.411749,24.312324'
        }
        return true
      }
      // 全国有两个长安区，特殊处理
      if (companyId === 236928128 && district.name === '长安区') {
        target = {
          name: '长安区',
          center: '114.52,38.05'
        }
        return true
      }
      if (item.name.includes(district.name)) {
        target = item
        return true
      } else {
        return false
      }
    })
    if (target.name) {
      districtList.push({
        position: target.center.split(','),
        level: MARKER_LEVEL.DISTRICT,
        name: target.name,
        count: district.count,
        onlineFlag: district.onlineFlag
      })
    }
  }

  this.provinceList = provinceList
  this.cityList = cityList
  this.districtList = districtList
  const res2 = await getCommunityListByCompanyId({
    companyId,
    showProject: this.showProject
  })
  const communityList = res2.data.data.map((item) => {
    return {
      count: item.projectcount,
      communityId: item.community_id,
      name: item.community_name,
      position: [item.longitude, item.latitude],
      onlineFlag: item.onlineFlag,
      level: MARKER_LEVEL.COMMUNITY
    }
  })
  this.communityList = communityList
  this.searchInput = res2.data.data.map((item) => {
    return {
      name: item.community_name,
      address: item.address,
      district: item.district,
      value: item.community_id,
      isOnline: item.onlineFlag,
      followsNum: item.followsNum,
      projectcount: item.projectcount
    }
  })
  // const detail = await searchProjectList({})
  // this.communityDetail = detail
}
async function onClickMarker(marker) {
  if (marker.name === '东莞市') {
    this.mapInstance.setZoom(ZOOM_LEVEL.DISTRICT + 1)
    marker.level = MARKER_LEVEL.DISTRICT
  }
  if (marker.level === MARKER_LEVEL.COMMUNITY) {
    this.mapInstance.setCenter(marker.position)
  } else {
    const project = await this.getNearestProject(
      marker.position[0],
      marker.position[1]
    )

    const levelMap = ['province', 'city', 'district', 'community']
    const projectPropertyMap = ['province', 'city', 'district', 'communityName']
    // findMarkerByLevel
    const target = this.findMarkerByLevel(
      levelMap[marker.level + 1],
      project[projectPropertyMap[marker.level + 1]]
    )
    // setCenter
    if (target) {
      this.mapInstance.setCenter(target.position)
    }
  }

  if (marker.level === MARKER_LEVEL.PROVINCE) {
    if (
      [
        '北京',
        '天津',
        '上海',
        '重庆',
        '北京市',
        '天津市',
        '上海市',
        '重庆市'
      ].includes(marker.name)
    ) {
      this.mapInstance.setZoom(ZOOM_LEVEL.CITY + 1)
    } else {
      this.mapInstance.setZoom(ZOOM_LEVEL.PROVINCE + 1)
    }
  } else if (marker.level === MARKER_LEVEL.CITY) {
    this.mapInstance.setZoom(ZOOM_LEVEL.CITY + 1)
  } else if (marker.level === MARKER_LEVEL.DISTRICT) {
    this.mapInstance.setZoom(ZOOM_LEVEL.DISTRICT + 1)
  } else {
    this.selectedCommunity = marker
    this.isShowProjectList = true
    this.mapInstance.setZoom(ZOOM_LEVEL.DISTRICT + 1)
    const communityId = marker.communityId
    const result = []
    this.searchInput.map((item) => {
      if (String(item.value) === String(communityId)) {
        item.district = item.district ? item.district : '其它地区'
        result.push(item.district)
        result.push(item.name)
      }
    })
    this.multySelectValue = result
  }
}

function moveTarget(target) {
  this.markers[this.markers.length - 1]?.isRecommend === 'Y' &&
    this.markers.splice(this.markers.length - 1, 1)
  if (target.value) {
    this.filter.id = target.value
    this.filter.region = target.name
    this.target = target.value
    this.multySelectValue = [target.district, target.name]
    if (!this.isManualLock) this.isLocked = false
  } else {
    this.filter.id = ''
    this.filter.region = ''
    this.target = ''
    const marker = {
      level: 3,
      name: target.name,
      position: target.position,
      isRecommend: 'Y'
    }
    this.mapInstance.setZoom(ZOOM_LEVEL.COMMUNITY)
    // 延时是为了zoom变化之后获取到最新的markers
    setTimeout(() => {
      this.markers.push(marker)
      this.mapInstance.setCenter(marker.position)
      this.selectedCommunity = marker
      if (!this.isManualLock) this.isLocked = true
    }, 800)
  }
}

function clearTarget() {
  this.filter.id = ''
  this.filter.region = ''
  this.multySelectValue = []
  this.target = ''
  this.selectedCommunity = {}
  this.markers[this.markers.length - 1]?.isRecommend === 'Y' &&
    this.markers.splice(this.markers.length - 1, 1)
  if (!this.isManualLock) this.isLocked = false
}
function onFilterChange(filter, value, communityId) {
  if (filter !== 'multy') {
    this.filter[filter] = value
  } else {
    this.$refs.listInputRef.setValue(value)
    this.filter.region = value
  }
  this.target = communityId
  this.moveToCommunity(communityId)
}

function onClickPlayer() {
  if (!this.isPlayerReady) {
    return
  }
  if (this.isPlaying) {
    this.player.stop()
    this.isPlaying = false
  } else {
    this.player.play()
    this.isPlaying = true
  }
}
function onClickCamera(camera) {
  this.selectedCamera = camera
}
async function initPlayer(deviceSerial) {
  if (process.client) {
    const EZUIKit = require('ezuikit-js')
    const token = (await getCameraToken(deviceSerial)).token
    return new Promise((resolve) => {
      this.player = new EZUIKit.EZUIKitPlayer({
        id: 'player-container', // 视频容器ID
        accessToken: token,
        // height: 591,
        url: `ezopen://open.ys7.com/${deviceSerial}/1.hd.live`,
        handleSuccess: () => {
          this.isPlayerReady = true
          this.isPlaying = true
          resolve()
        }
      })
    })
  } else {
  }
}
</script>
<template>
  <div
    ref="pageEl"
    :class="{ 'dark-mode': darkMode }"
    class="projectlist_page_container"
  >
    <div v-if="darkMode && isMapReady && !fullscreen" class="r-mask"></div>
    <el-dialog :visible.sync="isShowQr" width="440px">
      <div class="qr_wrapper">
        <div
          style="
            font-size: 20px;
            color: #444444;
            font-weight: 500;
            margin: 20px 0 30px 0;
          "
        >
          扫码看工地
        </div>
        <vue-qrcode :value="qrUrl" :options="{ width: 270, margin: 0 }" />
        <div
          style="
            height: 37px;
            border-radius: 19px;
            color: #9b9b9b;
            font-size: 14px;
            background: #f2f2f2;
            line-height: 37px;
            padding: 0 20px;
            margin-top: 30px;
          "
        >
          微信扫码，手机端也能查看工地哦~
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="isShowPlayer" width="1340px">
      <div :class="{ 'dark-mode': darkMode }" class="player-dialog-wrapper">
        <img
          @click="isShowPlayer = false"
          src="./img/close.png"
          class="close-button"
        />
        <div id="player-container">
          <div @click="onClickPlayer" class="player-mask">
            <img
              v-if="!isPlaying && isPlayerReady"
              src="./img/play.png"
              width="80"
            />
          </div>
        </div>
        <div class="camera-list-wrapper">
          <div class="project-title-wrapper">
            <div class="project-title">{{ selectedProject.projectName }}</div>
            <div class="camera-num">
              {{ `当前有${selectedProject.deviceOnlineNum}个摄像头直播中` }}
            </div>
            <div class="camera-dividing-line"></div>
          </div>
          <div class="camera-scroll-wrapper">
            <div
              v-for="camera in selectedProject.deviceList"
              :key="camera.yqzDeviceId"
              @click="onClickCamera(camera)"
              class="camera-item-wrapper"
            >
              <img :src="camera.coverImageUrl" class="camera-img" />
              <div
                :class="{ selected: camera === selectedCamera }"
                class="camera-title"
              >
                {{ camera.deviceRemark }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="isShowPassword"
      width="350px"
      custom-class="password-dialog"
    >
      <div class="password-dialog-wrapper">
        <div class="password-dialog-title">工地直播观看密码</div>
        <div class="password-dialog-input">
          <el-input
            v-model="inputPassword"
            maxlength="6"
            placeholder="请输入观看密码"
          ></el-input>
        </div>
        <div @click="onSubmitPassword" class="password-dialog-button">确定</div>
      </div>
    </el-dialog>
    <div
      v-show="isMapReady"
      :class="{ 'dark-mode': darkMode }"
      class="projectlist_header_wrapper"
    >
      <a :href="`/company/${companyId}`" class="title_logo" target="_blank">
        <img :src="company.logoOssUrl" class="logo" alt="" />
        <div class="title">{{ `${company.shortName}` }}</div>
      </a>
      <a
        :class="{ 'dark-mode': darkMode }"
        :href="`${pcWorkerUrl}camera/live/bigscreen?companyId=${companyId}`"
        class="live-button"
      >
        查看工地直播
      </a>
      <div @click="isShowQr = true" class="qrbtn_wrapper cursor-point">
        <svg
          width="14px"
          height="14px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <title>编组</title>
          <g
            id="页面-1"
            stroke="none"
            stroke-width="1"
            fill="none"
            fill-rule="evenodd"
          >
            <g
              id="大屏地图（浅色模式）"
              transform="translate(-1535.000000, -22.000000)"
            >
              <g
                id="编组-4备份-2"
                transform="translate(1520.000000, 10.000000)"
              >
                <g id="编组" transform="translate(15.000000, 12.000000)">
                  <rect id="矩形" x="0" y="0" width="16" height="16"></rect>
                  <g
                    id="形状"
                    :fill="darkMode ? '#FFFFFF' : '#444444'"
                    fill-rule="nonzero"
                  >
                    <path
                      d="M1.77379261,10.6143466 L0.00532670455,10.6143466 L0.00532670455,15.9161932 L5.30894886,15.9161932 L5.30894886,14.1495028 L1.77379261,14.1495028 L1.77379261,10.6143466 Z M10.612571,0.00710227273 L10.612571,1.77556818 L14.1477273,1.77556818 L14.1477273,5.31072443 L15.9144176,5.31072443 L15.9144176,0.00710227273 L10.612571,0.00710227273 Z M1.77379261,1.77556818 L5.30894886,1.77556818 L5.30894886,0.00710227273 L0.00532670455,0.00710227273 L0.00532670455,5.31072443 L1.77379261,5.31072443 L1.77379261,1.77556818 Z M14.1477273,14.1495028 L10.612571,14.1495028 L10.612571,15.9161932 L15.9144176,15.9161932 L15.9144176,10.6143466 L14.1477273,10.6143466 L14.1477273,14.1495028 Z M14.1477273,8.84588068 L14.1477273,7.07919034 L1.77379261,7.07919034 L1.77379261,8.84588068 L10.612571,8.84588068 L14.1477273,8.84588068 Z"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
        <div style="font-size: 14px; margin-left: 11px">扫码看工地</div>
      </div>
      <div class="button_wrapper">
        <div class="mode_selector cursor-point" style="width:125px;">
          <el-select
            :value="showProject"
            @change="onChangeShowProject"
            :popper-append-to-body="false"
            popper-class="map-selector"
          >
            <el-option
              v-for="option of showProjectOptions"
              :key="option.value"
              :value="option.value"
              :label="option.name"
            />
          </el-select>
        </div>
        <div class="mode_selector cursor-point">
          <el-select
            :popper-append-to-body="false"
            :value="darkMode"
            @change="
              (value) => {
                $store.commit('config/setDarkmode', value)
              }
            "
            popper-class="map-selector"
          >
            <el-option :value="false" label="浅色模式" />
            <el-option :value="true" label="深色模式" />
          </el-select>
        </div>
        <div @click="onClickFullScreen" class="fullscreen_wrapper cursor-point">
          <div :style="'font-size: 14px;'">
            {{ fullscreen ? '显示浮窗' : '隐藏浮窗' }}
          </div>
        </div>

        <div
          @click="onClickMakeFullScreen"
          class="fullscreen_wrapper cursor-point"
        >
          <svg
            v-if="!isFullScreen"
            width="14px"
            height="14px"
            viewBox="0 0 16 16"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>编组</title>
            <g
              id="页面-1"
              stroke="none"
              stroke-width="1"
              fill="none"
              fill-rule="evenodd"
            >
              <g
                id="大屏地图（浅色模式）"
                transform="translate(-1817.000000, -22.000000)"
              >
                <g id="编组-4" transform="translate(1802.000000, 10.000000)">
                  <g id="编组" transform="translate(15.000000, 12.000000)">
                    <rect id="矩形" x="0" y="0" width="16" height="16"></rect>
                    <path
                      id="形状"
                      :fill="darkMode ? '#FFFFFF' : '#444444'"
                      d="M11.2951111,5.96177777 L14.1146667,3.14222223 L16,5.02755556 L16,0 L10.9724444,0 L12.8577778,1.88533333 L10.0382222,4.7048889 L11.2951111,5.96177777 Z M12.8577778,14.1146667 L10.9724444,16 L16,16 L16,10.9724444 L14.1146667,12.8577778 L11.2951111,10.0382222 L10.0382222,11.2951111 L12.8577778,14.1146667 Z M4.7048889,10.0382222 L1.88533333,12.8577778 L0,10.9724444 L0,16 L5.02755556,16 L3.14222223,14.1146667 L5.96177777,11.2951111 L4.7048889,10.0382222 Z M3.14222223,1.88533333 L5.02755556,0 L0,0 L0,5.02755556 L1.88533333,3.14222223 L4.7048889,5.96177777 L5.96177777,4.7048889 L3.14222223,1.88533333 Z"
                      fill-rule="nonzero"
                    ></path>
                  </g>
                </g>
              </g>
            </g>
          </svg>
          <div
            :style="
              isFullScreen
                ? 'font-size: 14px;'
                : 'font-size: 14px;margin-left: 5px;'
            "
          >
            {{ isFullScreen ? '退出全屏' : '全屏' }}
          </div>
        </div>
      </div>
    </div>
    <img
      v-if="darkMode && isMapReady"
      class="header_flash"
      src="./img/flash.png"
      alt=""
    />
    <div class="projectlist_left_panel">
      <div
        v-show="isMapReady && !fullscreen"
        :class="{ 'dark-mode': darkMode }"
        class="projectlist_info_card"
      >
        <img
          v-if="darkMode"
          class="cornor_dark cornor_dark__topleft"
          src="./img/cornor.png"
          alt=""
        />
        <img
          v-if="darkMode"
          class="cornor_dark cornor_dark__topright"
          src="./img/cornor.png"
          alt=""
        />
        <img
          v-if="darkMode"
          class="cornor_dark cornor_dark__bottomright"
          src="./img/cornor.png"
          alt=""
        />
        <img
          v-if="darkMode"
          class="cornor_dark cornor_dark__bottomleft"
          src="./img/cornor.png"
          alt=""
        />
        <div :class="{ 'dark-mode': darkMode }" class="card_item_wrapper">
          <img
            v-if="darkMode"
            src="./img/xq-dark.png"
            style="width: 29px; height: 31px; margin-right: 20px"
          />
          <img
            v-else
            src="./img/xq-light.png"
            style="width: 29px; height: 31px; margin-right: 20px"
          />
          <div>
            <div class="card_item_title">小区数</div>
            <div class="card_item_number">{{ projectData.totalCommunity }}</div>
          </div>
        </div>
        <div :class="{ 'dark-mode': darkMode }" class="card_item_wrapper">
          <img
            v-if="darkMode"
            src="./img/all-dark.png"
            style="width: 33px; height: 27px; margin-right: 20px"
          />
          <img
            v-else
            src="./img/all-light.png"
            style="width: 33px; height: 27px; margin-right: 20px"
          />
          <div>
            <div class="card_item_title">全部工地数</div>
            <div class="card_item_number">{{ projectData.totalProject }}</div>
          </div>
        </div>
        <div :class="{ 'dark-mode': darkMode }" class="card_item_wrapper">
          <img
            v-if="darkMode"
            src="./img/ed-dark.png"
            style="width: 30px; height: 30px; margin-right: 20px"
          />
          <img
            v-else
            src="./img/ed-light.png"
            style="width: 30px; height: 30px; margin-right: 20px"
          />
          <div>
            <div class="card_item_title">完工数</div>
            <div class="card_item_number">{{ projectData.finishProject }}</div>
          </div>
        </div>
        <div :class="{ 'dark-mode': darkMode }" class="card_item_wrapper">
          <img
            v-if="darkMode"
            src="./img/ing-dark.png"
            style="width: 31px; height: 31px; margin-right: 20px"
          />
          <img
            v-else
            src="./img/ing-light.png"
            style="width: 31px; height: 31px; margin-right: 20px"
          />
          <div>
            <div class="card_item_title">在建数</div>
            <div class="card_item_number">
              {{ projectData.unFinishProject }}
            </div>
          </div>
        </div>
      </div>
      <div
        v-show="isMapReady && (!fullscreen || isShowProjectList)"
        class="projectlist_list_panel"
      >
        <img
          v-if="darkMode"
          class="cornor_dark cornor_dark__topleft"
          src="./img/cornor.png"
          alt=""
        />
        <img
          v-if="darkMode"
          class="cornor_dark cornor_dark__topright"
          src="./img/cornor.png"
          alt=""
        />
        <img
          v-if="darkMode"
          class="cornor_dark cornor_dark__bottomright"
          src="./img/cornor.png"
          alt=""
        />
        <img
          v-if="darkMode"
          class="cornor_dark cornor_dark__bottomleft"
          src="./img/cornor.png"
          alt=""
        />
        <div
          :class="{ 'dark-mode': darkMode }"
          class="projectlist_serach_input"
        >
          <ProjectListInput
            ref="listInputRef"
            :community-list="searchInput"
            @move-to-target="moveTarget"
            @clear-target="clearTarget"
          />
          <div
            :style="{
              width: '1px',
              height: '18px',
              margin: '0 10px 0 10px',
              background: darkMode ? 'rgba(255, 255, 255, 0.45)' : ' #EFF1F2'
            }"
          ></div>
          <div style="width: 100px">
            <ProjectListSelectSingle
              ref="s_1"
              @change-list="onFilterChange"
              type="sort"
            />
          </div>
        </div>
        <div
          :class="{ 'dark-mode': darkMode }"
          class="projectlist_select_wrapper"
        >
          <ProjectListSelectMulty
            ref="s_m_1"
            :value="multySelectValue"
            @change-list="onFilterChange"
            class="select-multy"
          />
          <ProjectListSelectSingle
            ref="s_2"
            @change-list="onFilterChange"
            type="style"
          />
          <ProjectListSelectSingle
            ref="s_3"
            @change-list="onFilterChange"
            type="room"
          />
        </div>
        <div
          :class="{ 'dark-mode': darkMode }"
          class="projectlist_list_wrapper"
        >
          <ProjectList
            :style="{
              height: fullscreen ? 'calc(100vh - 190px)' : 'calc(100vh - 360px)'
            }"
            :filter="filter"
          />
        </div>
      </div>
    </div>
    <div
      v-if="!fullscreen && isMapReady"
      :class="{ 'dark-mode': darkMode }"
      class="project_distribution_panel"
    >
      <StageDistribution :day="-1" :company-id="companyId" />
    </div>
    <no-ssr placeholder="Loading...">
      <div @mousedown="onClickSelectBlur" @click="onClickSelectBlur">
        <el-amap
          ref="mapRef"
          :map-style="darkMode ? 'dark' : 'normal'"
          :zoom="zoom"
          :zooms="[4, 18]"
          :center="center"
          :events="events"
          :plugin="plugin"
          vid="smart-map"
        >
          <el-amap-marker
            v-for="(marker, index) in markers"
            :key="index"
            :offset="marker.level !== 3 ? [0, 0] : [-125, -16]"
            :position="marker.position"
            :z-index="
              marker === selectedCommunity
                ? '1000'
                : marker.onlineFlag === 'Y'
                ? '500'
                : '100'
            "
          >
            <div
              v-if="darkMode && marker.level !== 3"
              style="width: 0; height: 0; position: relative"
            >
              <div class="bigmarker-wrapper__dark no-click">
                <div class="bigmarker-circle__first"></div>
                <div class="bigmarker-circle__second"></div>
              </div>
              <div
                @click="onClickMarker(marker)"
                class="bigmarker-content dark-mode"
              >
                <div class="bigmarker-text dark-mode">
                  <img v-if="marker.onlineFlag === 'Y'" src="./img/live.gif" />
                  <span>{{ marker.name }}</span>
                </div>
                <div class="bigmarker-count dark-mode">
                  {{ `${marker.count}套` }}
                </div>
              </div>
            </div>

            <div v-else-if="marker.level !== 3">
              <div
                @click="onClickMarker(marker)"
                class="bigmarker-content"
                style="transform: translate(-50%, -50%)"
              >
                <div class="bigmarker-text">
                  <img
                    v-if="marker.onlineFlag === 'Y' && darkMode"
                    src="./img/live.gif"
                  />
                  <img
                    v-if="marker.onlineFlag === 'Y' && !darkMode"
                    src="./img/live-white.gif"
                  />
                  <span>{{ marker.name }}</span>
                </div>
                <div class="bigmarker-count">
                  {{ `${marker.count}套` }}
                </div>
              </div>
            </div>
            <div v-else @click="onClickMarker(marker)" class="smarker-wrapper">
              <div
                :class="{
                  'dark-mode': darkMode,
                  marker_selected: marker === selectedCommunity
                }"
                class="smarker-content-wrapper"
              >
                <div v-if="marker.onlineFlag === 'Y'">
                  <img
                    v-if="darkMode && marker !== selectedCommunity"
                    src="./img/live.gif"
                    width="11"
                    height="11"
                  />
                  <img
                    v-else
                    src="./img/live-white.gif"
                    width="11"
                    height="11"
                  />
                </div>
                <div class="smarker-content-text">
                  {{
                    `${marker.name.slice(0, 8)}${
                      marker.name.length > 8 ? '...' : ''
                    }${marker.count > 0 ? `（${marker.count || 0}个）` : ''}`
                  }}
                </div>
              </div>
              <div
                v-if="
                  marker === selectedCommunity &&
                    marker.onlineFlag === 'Y' &&
                    selectedProjectList.length
                "
                :class="{ 'dark-mode': darkMode }"
                class="live-project-list-wrapper"
              >
                <div class="live-list-title">
                  {{ `${selectedProjectList.length}个工地直播中` }}
                </div>
                <div class="live-list-dividing-line"></div>
                <div class="project-list-wrapper">
                  <div
                    v-for="liveProject in selectedProjectList"
                    :key="liveProject.projectId"
                    @click.stop="onClickLiveProject(liveProject)"
                    class="project-item"
                  >
                    <div class="project-img-wrapper">
                      <div class="project-stage">
                        {{ liveProject.stageName }}
                      </div>
                      <img :src="liveProject.imageUrl" class="project-img" />
                    </div>
                    <div class="live-project-title">
                      {{ liveProject.projectName }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-amap-marker>
        </el-amap>
      </div>
    </no-ssr>

    <div v-show="isMapReady && !fullscreen">
      <Bullets :company-id="companyId" />
    </div>
    <div
      @click.stop="onClickLock"
      :class="{ 'lock-button__selected': isLocked }"
      class="lock-button"
    >
      锁定层级
    </div>
  </div>
</template>
<style lang="scss" scoped>
.lock-button {
  position: absolute;
  left: 403px;
  bottom: 120px;
  z-index: 1000;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #444444;
  line-height: 16px;
  width: 35px;
  padding: 5px 0;
  text-align: center;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 1px 1px 10px 0px rgba(204, 204, 204, 0.5);
  border-radius: 4px;
  border: 1px solid #cccccc;
  cursor: pointer;
}

.lock-button__selected {
  background: #00bfd1;
  box-shadow: 1px 1px 10px 0px rgba(204, 204, 204, 0.5);
  color: #ffffff;
  border: 1px solid #00bfd1;
}

.cursor-point {
  cursor: pointer;
}

.projectlist_list_panel {
  :deep(.el-input input) {
    color: #444;
  }

  :deep(.dark-mode) {
    .el-input input {
      color: white;
    }
  }
}

.no-click {
  pointer-events: none;
}

::-webkit-scrollbar {
  width: 0;
  height: 0;
}

:deep(.password-dialog) {
  border-radius: 6px;
}

.password-dialog-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.password-dialog-title {
  font-size: 20px;
  font-weight: 500;
  color: #444444;
  line-height: 28px;
  margin-top: 20px;
}

.password-dialog-input {
  margin-top: 20px;

  :deep(input) {
    width: 270px;
    background: #f8f8f8;
    border-radius: 4px;
  }
}

.password-dialog-button {
  width: 270px;
  height: 48px;
  background: #00bfd1;
  border-radius: 4px;
  margin-top: 35px;
  margin-bottom: 20px;
  font-weight: 500;
  color: #ffffff;
  line-height: 48px;
  text-align: center;
}

.r-mask {
  position: absolute;
  width: 300px;
  top: 0px;
  bottom: 0px;
  right: 0px;
  background: linear-gradient(-90deg, #000001 0%, rgba(0, 0, 1, 0) 100%);
  z-index: 3;
}

.mode_selector {
  width: 110px;
  margin-left: 10px;

  :deep(.el-input__inner) {
    font-size: 14px;
    color: #444444;
    height: 36px;
  }

  :deep(.el-input__suffix) {
    font-size: 14px;
    color: #444444;
  }

  :deep(.el-input__icon) {
    line-height: inherit;
    color: #444444;
  }

  :deep(.el-input__icon::before) {
    color: #444444;
  }

  :deep(.el-input__suffix-inner) {
    line-height: inherit;
  }
}

.projectlist_list_panel {
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  width: 360px;
  // height: calc(100vh - 265px);
  position: relative;
  z-index: 10;

  :deep(.el-input__inner) {
    border: none;
  }

  .projectlist_serach_input {
    width: 100%;
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    padding: 5px 10px;
    background: #ffffff;
    border-radius: 6px;
    box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
    color: #444;
  }

  .projectlist_serach_input.dark-mode {
    background: #241e0d;

    :deep(input) {
      color: #ffffff;
    }
  }

  .projectlist_select_wrapper {
    color: #444;
    background: #ffffff;
    display: flex;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
  }

  .projectlist_select_wrapper.dark-mode {
    background: #241e0d;
  }

  .projectlist_list_wrapper {
    color: #444;
    background: white;
    border-bottom-left-radius: 6px;
    border-bottom-right-radius: 6px;
  }

  .projectlist_list_wrapper.dark-mode {
    background: linear-gradient(180deg, #241e0d 0%, #1a1509 100%);
  }
}

.projectlist_header_wrapper {
  height: 55px;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: #ffffff;
  display: flex;
  justify-content: center;

  .title_logo {
    display: flex;
    align-items: center;

    .logo {
      width: 34px;
      height: 34px;
      border-radius: 7px;
      border: 1px solid #f4f4f4;
      margin-right: 10px;
    }

    .title {
      font-size: 26px;
      font-weight: 500;
      color: #444444;
      line-height: 37px;
      letter-spacing: 1px;
    }
  }

  .live-button {
    height: 36px;
    position: absolute;
    left: 20px;
    top: 9px;
    border-radius: 5px;
    border: 1px solid #e3e3e3;
    color: #444444;
    padding: 0 15px;
    font-size: 14px;
    cursor: pointer;
    line-height: 36px;
  }

  .live-button.dark-mode {
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #ffffff;
    background: #4d4b45;
  }

  .button_wrapper {
    height: 55px;
    position: absolute;
    right: 20px;
    display: flex;
    align-items: center;
  }

  .qrbtn_wrapper {
    position: absolute;
    top: 9px;
    left: 145px;
    height: 36px;
    border-radius: 5px;
    border: 1px solid #e3e3e3;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    color: #444444;
  }

  .fullscreen_wrapper {
    height: 36px;
    border-radius: 5px;
    border: 1px solid #e3e3e3;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    color: #444444;
    margin-left: 10px;
  }
}

.projectlist_header_wrapper.dark-mode {
  height: 82px;
  background-image: url('./img/header-dark.png');
  background-size: 100vw 82px;
  background-color: rgba(0, 0, 0, 0);

  :deep(.el-input__inner) {
    color: #ffffff;
    background: #4d4b45;
    border: 1px solid rgba(255, 255, 255, 0.3);
  }

  :deep(.el-input__icon::before) {
    color: #ffffff;
  }

  .title {
    color: #ffffff;
  }

  .qrbtn_wrapper {
    background: #4d4b45;
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #ffffff;
  }

  .fullscreen_wrapper {
    background: #4d4b45;
    border: 1px solid rgba(255, 255, 255, 0.3);
    color: #ffffff;
  }
}

.header_flash {
  -webkit-user-drag: none;
  width: 380px;
  height: 160px;
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translate(-50%, 0);
}

.projectlist_left_panel {
  z-index: 10;
  position: fixed;
  top: 75px;
  left: 20px;
}

.projectlist_info_card {
  width: 360px;
  height: 150px;
  position: relative;
  margin-bottom: 20px;
  background: #ffffff;
  z-index: 10;
  border-radius: 6px;
  display: flex;
  flex-wrap: wrap;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  // border-top: 3px solid #463c1d;
}

.cornor_dark {
  position: absolute;
  width: 11px;
  height: 11px;
}

.cornor_dark__topleft {
  top: 0;
  left: 0;
}

.cornor_dark__topright {
  top: 0;
  right: 0;
  transform: rotate(90deg);
}

.cornor_dark__bottomright {
  bottom: 0;
  right: 0;
  transform: rotate(180deg);
}

.cornor_dark__bottomleft {
  bottom: 0;
  left: 0;
  transform: rotate(270deg);
}

.projectlist_info_card.dark-mode {
  // box-sizing: border-box;
  // box-shadow: 0px 0px 0px 10px black inset;
  background: linear-gradient(180deg, #241e0d 0%, #1a1509 100%);
}

.card_item_wrapper {
  width: 50%;
  height: 75px;
  display: flex;
  align-items: center;
  padding: 0 0 0 20px;
}

.card_item_title {
  font-size: 16px;
  color: #9b9b9b;
  margin-bottom: 2px;
  line-height: 22px;
}

.card_item_wrapper.dark-mode .card_item_title {
  color: #ffcf66;
}

.card_item_number {
  font-size: 18px;
  font-weight: 500;
  line-height: 25px;
  color: #444;
}

.card_item_wrapper.dark-mode .card_item_number {
  color: #ffffff;
}

.project_distribution_panel {
  width: 320px;
  height: 245px;
  position: fixed;
  top: 75px;
  right: 20px;
  z-index: 10;
  background: #ffffff;
  border-radius: 6px;
  padding: 0 20px;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
}

.project_distribution_panel.dark-mode {
  background: linear-gradient(270deg, #0d0900 0%, rgba(64, 59, 45, 0.8) 100%);
}

.qr_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  // height: 300px;
}

.project-title {
  font-size: 18px;
  font-weight: 500;
  color: #444444;
  margin: 20px 0 10px 0;
}

.project-title.dark-mode {
  color: #ffffff;
}

.camera-list-wrapper {
  padding-left: 15px;
  width: 245px;
}

.camera-num {
  font-size: 12px;
  color: #9b9b9b;
  margin-bottom: 15px;
}

.camera-num.dark-mode {
  color: #ffffff;
}

.camera-dividing-line {
  width: 260px;
  height: 1px;
  background: #e6e6e6;
}

.camera-scroll-wrapper {
  overflow: scroll;
  max-height: 495px;
}

.camera-item-wrapper {
  margin-top: 15px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.camera-img {
  width: 120px;
  border-radius: 4px;
}

.camera-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-left: 10px;
}

.camera-title.selected {
  color: #00bfd1;
}
</style>
<style lang="scss" scoped>
.projectlist_page_container.dark-mode {
  .lock-button__selected {
    background: #ffcf66;
    box-shadow: 1px 1px 10px 0px rgba(204, 204, 204, 0.5);
    color: #444444;
    border: 1px solid #ffcf66;
  }
}
</style>
<style lang="scss">
.v-modal {
  opacity: 0.7 !important;
}

.amap-marker-content {
  width: 0;
}

.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}

@keyframes close {
  from {
    flex: 480px 0 0;
  }

  to {
    flex: 0px 0 0;
  }
}

@keyframes open {
  from {
    flex: 0px 0 0;
  }

  to {
    flex: 480px 0 0;
  }
}

.projectlist_page_container {
  .app_header {
    margin-bottom: 0;

    .app_header_logo {
      width: 36px;
      height: 36px;

      > img {
        object-fit: cover;
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }

    .app_header_project_short_name {
      font-size: 20px;
      font-weight: 500;
      color: rgba(42, 42, 42, 1);
      line-height: 20px;
      padding-left: 10px;
    }
  }
}

.is-focus {
  > input {
    border-color: #37c6d8 !important;
  }
}

.in-active-path,
.is-active {
  span,
  i {
    color: #37c6d8 !important;
  }
}

#smart-map {
  width: 100vw;
  height: 100vh;
}

.bigmarker-wrapper__dark {
  width: 250px;
  height: 250px;
  position: absolute;
  top: 0px;
  left: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
}

.bigmarker-circle__first {
  width: 250px;
  height: 250px;
  position: absolute;
  top: 0;
  left: 0;
  border-radius: 125px;
  background: radial-gradient(
    rgba(235, 231, 199, 0) 0%,
    rgba(235, 231, 199, 0) 33%,
    #ffcf66 100%
  );
  opacity: 0.06;
  animation-duration: 1.5s;
  animation-timing-function: ease;
  animation-name: first-circle;
  animation-iteration-count: infinite;
}

@keyframes first-circle {
  from {
    opacity: 0.06;
    transform: scale(0.3);
  }

  78% {
    opacity: 0.06;
    transform: scale(1);
  }

  to {
    opacity: 0;
  }
}

.bigmarker-circle__second {
  width: 250px;
  height: 250px;
  border-radius: 50%;
  background: radial-gradient(
    rgba(235, 231, 199, 0) 0%,
    rgba(235, 231, 199, 0) 33%,
    #ffcf66 100%
  );
  opacity: 0.15;
  animation-duration: 1.5s;
  animation-name: second-circle;
  animation-timing-function: ease;
  animation-delay: 0.33s;
  animation-iteration-count: infinite;
}

@keyframes second-circle {
  from {
    opacity: 0.15;
    transform: scale(0.3);
  }

  78% {
    opacity: 0.15;
    transform: scale(1);
  }

  to {
    opacity: 0;
  }
}

.bigmarker-content {
  position: absolute;
  width: 85px;
  height: 85px;
  background: #00bfd1;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bigmarker-content:hover {
  background-color: #fe733d;
}

.bigmarker-text {
  font-size: 13px;
  font-weight: 500;
  color: #ffffff;
  text-align: center;
  max-width: 60px;
}

.bigmarker-count {
  font-size: 13px;
  color: #ffffff;
}

.bigmarker-content.dark-mode {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  position: absolute;
  top: -40px;
  left: -40px;
  background: #ffcf66;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.bigmarker-text.dark-mode {
  color: #444444;
}

.bigmarker-count.dark-mode {
  color: #444444;
}

.smarker-wrapper {
  height: 32px;
  width: 250px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.smarker-content-wrapper {
  color: #ffffff;
  background: #00bfd1;
  border-radius: 5px;
  padding: 8px 10px;
  position: relative;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
}

.smarker-content-wrapper:hover {
  background-color: #fe733d;
}

.smarker-content-wrapper::after {
  content: '';
  width: 0;
  height: 0;
  border-left: 8px solid transparent;
  border-right: 8px solid transparent;
  border-top: 8px solid #00bfd1;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translate(-50%, 100%);
}

.smarker-content-wrapper:hover::after {
  border-top: 8px solid #fe733d;
}

.smarker-content-wrapper.dark-mode {
  color: #444444;
  background: #ffcf66;
  box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3);
}

.smarker-content-wrapper.dark-mode::after {
  border-top: 8px solid #ffcf66;
}

// .smarker-content-wrapper.dark-mode::after {
//   border-top: 8px solid #ffcf66;
// }
.smarker-content-text {
  font-weight: 500;
  font-size: 13px;
  line-height: 13px;
  letter-spacing: 1.5px;
  margin-left: 5px;
}

.marker_selected {
  color: #ffffff;
  background: #fb7347;
}

.marker_selected::after {
  border-top: 8px solid #fb7347;
}

.marker_selected.dark-mode {
  color: #ffffff;
  background: #fe733d;
}

.marker_selected.dark-mode::after {
  border-top: 8px solid #fe733d;
}

// .amap-toolbar {
//   right: 0 !important;
//   left: 390px !important;
//   // top: 0 !important;
//   bottom: 100px !important;
//   height: 300px;
// }
</style>
<style lang="scss">
.map-selector {
  .el-select-dropdown__item.selected {
    color: #00bfd1;
  }
}

.el-popper.el-cascader__dropdown {
  max-height: 300px;
  overflow: scroll;
}

.el-scrollbar.el-cascader-menu {
  max-height: 300px;
  overflow: scroll;
}

.van-list {
  overflow-y: hidden;
}

.live-project-list-wrapper {
  position: absolute;
  top: 40px;
  width: 255px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  padding: 0 15px 20px 15px;
}

.live-project-list-wrapper.dark-mode {
  background: rgba(31, 25, 11, 0.8);
  border-radius: 5px;
  border: 1px solid rgba(255, 201, 76, 0.25);
  backdrop-filter: blur(5px);

  .live-list-title {
    color: #ffffff;
  }

  .live-list-dividing-line {
    background: rgba(255, 201, 76, 0.15);
  }

  .project-stage {
    background: rgba(77, 64, 35, 0.7);
    color: #ffcf66;
  }

  .live-project-title {
    color: #ffffff;
  }
}

.live-list-title {
  font-size: 16px;
  font-weight: 500;
  color: #444444;
  line-height: 25px;
  margin: 15px 0 10px 0;
}

.live-list-dividing-line {
  height: 1px;
  background: #e6e6e6;
}

.project-list-wrapper {
  // overflow: scroll;
  // max-height: 260px;
}

.project-item {
  display: flex;
  align-items: center;
  margin-top: 15px;
  cursor: pointer;
}

.project-img-wrapper {
  position: relative;
  width: 88px;
  height: 55px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.project-stage {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(77, 77, 77, 0.7);
  border-radius: 4px 0px 4px 0px;
  font-size: 11px;
  color: #ffffff;
  line-height: 16px;
  padding: 0 5px;
}

.project-img {
  width: 88px;
  height: 55px;
}

.live-project-title {
  margin-left: 10px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  font-weight: 500;
  color: #444444;
  line-height: 20px;
  font-size: 14px;
}

.player-dialog-wrapper {
  width: 1340px;
  height: 591px;
  background: white;
  border-radius: 5px;
  position: absolute;
  top: -10px;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
}

.player-dialog-wrapper.dark-mode {
  background: #1a1711;
  border: 1px solid rgba(255, 201, 76, 0.25);

  .project-title {
    color: #ffffff;
  }

  .camera-title {
    color: #ffffff;
  }

  .camera-title.selected {
    color: #ffcf66;
  }

  .camera-dividing-line {
    background: rgba(255, 201, 76, 0.15);
  }
}

.close-button {
  position: absolute;
  top: -17px;
  right: -17px;
  width: 34px;
  height: 34px;
  cursor: pointer;
}

#player-container {
  width: 1050px;
  position: relative;
}

.player-mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
